<template>
  <section id="setting">
    <div
      v-if="loadingCurrentCorporation"
      class="loading-container"
    >
      <img
        alt="loading"
        src="@shared/assets/img/general/loading.svg"
      >
    </div>
    <CompanyInfo
      v-else
      :currentCorporation="currentCorp"
      :partnerSettings="partnerSettings"
      :serviceCategoryList="serviceCategoryList"
      :partnerIndustry="partnerIndustry"
      :update="updateCorporation"
      :updateAddress="updateCorporationAddress"
      :updateLogo="updateCorporationLogo"
      :updatePartnerSetting="updateCorporationSetting"
      :alertOptions="alertTypes"
      :adminRole="adminRole"
      :states="states"
      :countries="countries"
      :taxExemptCategory="taxExemptCategory"
      :toggleActionModal="toggleActionModal"
      :selectedPaymentMethod="selectedPaymentMethod"
      :agreements="agreements"
      :loadingPaymentMethod="loadingPaymentMethod"
    />
    <ActionModal :currentCorp="currentCorp" />
  </section>
</template>

<script>
import settingMixin from '@shared/mixins/settingMixin';
import partnerSettingsMixin from '@shared/mixins/partnerSettingsMixin';
import CompanyInfo from '@shared/components/setting/CompanyInfo.vue';
import ActionModal from '@shared/components/setting/ActionModal.vue';

export default {
  name: 'SettingView',
  components: {
    ActionModal,
    CompanyInfo,
  },
  metaInfo: {
    title: 'SmartAC.com | Setting',
  },
  mixins: [settingMixin, partnerSettingsMixin],
  data() {
    return {
      activeTab: 'general',
    };
  },
  computed: {
    currentCorp() {
      return this.currentCorporation;
    },
    activeDetailTab() {
      if (this.warningDetailTab && !this.showWarningOnExit) {
        return this.warningDetailTab;
      }
      return this.activeTab;
    },
    tabOptions() {
      let options = [
        {
          label: 'General',
          value: 'general',
        },
        {
          label: 'Platform Settings',
          value: 'platform',
        },
      ];
      if (this.adminRole === 'admin') {
        options = [
          ...options,
          {
            label: 'Dashboard Users',
            value: 'dashboardUsers',
          },
        ];
      }
      options = [
        ...options,
        {
          label: 'Integrations',
          value: 'integrations',
        },
      ];
      return options;
    },
  },
  watch: {
    showWarningOnExit(nv) {
      if (!nv && this.warningDetailTab) {
        this.activeTab = this.warningDetailTab;
      }
    },
  },
  async mounted() {
    if (this.isManufactureAdmin) {
      this.$router.replace('/quality');
    } else {
      await Promise.all([
        this.$store.dispatch('getUserCorpSetting'),
        this.$store.dispatch('getServiceCategories'),
        this.$store.dispatch('getTaxExemptCategory'),
        this.$store.dispatch('getAlertList'),
        this.$store.dispatch('getBillingPaymentMethod', this.currentCorporation.id),
        this.$store.dispatch('getAgreements'),
      ]);
      if (this.$route?.query) {
        let tab = null;
        Object.keys(this.$route.query).forEach((q) => {
          if (q.toLowerCase() === 'tab') {
            tab = this.$route.query[q];
          }
        });
        if (tab) {
          const activeTab = this.tabOptions.find((o) => (
            o.value.toLowerCase() === tab.toLowerCase()
          ));
          if (activeTab) {
            this.activeTab = activeTab.value;
          }
        }
      }
    }
  },
  methods: {
    async updateCorporation(payload) {
      await this.$store.dispatch('updateCorporation', payload);
    },
    async updateCorporationAddress(payload) {
      await this.$store.dispatch('updateCorporationAddress', payload);
    },
    async updateCorporationSetting(payload) {
      await this.$store.dispatch('updateCorporationSetting', payload);
    },
    async updateCorporationLogo(payload) {
      await this.$store.dispatch('updateCorporationLogo', payload);
    },
    changeTab(tab) {
      if (this.showWarningOnExit) {
        this.toggleModal(true, 'warning-save');
        this.changeSettingValue('warningDetailTab', tab);
      } else {
        this.changeSettingValue('warningDetailTab', '');
        this.activeTab = tab;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
section#setting {
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: $N5;

  .loading-container {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .top-container {
    display: flex;
    justify-content: center;
    background-color: $BLACK;
    //padding: 40px 100px 0 100px;

    .top {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      margin-bottom: 32px;
      max-width: 1705px;
      width: 100%;
    }
  }

  .body-container {
    flex: 1;
    background-color: $WHITE;
    padding: 20px 100px 90px 100px;
    width: 100%;
    display: flex;
    justify-content: center;
  }
}
</style>
